// extracted by mini-css-extract-plugin
module.exports = {"certificateWrapper":"_2tv6zt","certificateIcon":"Px4Ogy"};